import React from 'react'
import PartyInfo from '../../components/superAdmin/partyInfo/PartyInfo'

function PartyInfoPage() {
  return (
    <div>
        <PartyInfo />
    </div>
  )
}

export default PartyInfoPage